import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import logo from '../assets/images/logo-transparent-png.png';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="logo">
          <img src={logo} alt="Drive Inter" />
        </div>
        <ul className={`nav-links ${menuOpen ? 'active' : ''}`}>
          <li>
            <Link to="hero" smooth={true} duration={500} onClick={() => setMenuOpen(false)}>
              Accueil
            </Link>
          </li>
          <li>
            <Link to="services" smooth={true} duration={500} onClick={() => setMenuOpen(false)}>
              Services
            </Link>
          </li>
          <li>
            <Link to="about" smooth={true} duration={500} onClick={() => setMenuOpen(false)}>
              À Propos
            </Link>
          </li>
          <li>
            <Link to="fleet" smooth={true} duration={500} onClick={() => setMenuOpen(false)}>
              Flotte
            </Link>
          </li>
          <li>
            <Link to="team" smooth={true} duration={500} onClick={() => setMenuOpen(false)}>
              Équipe
            </Link>
          </li>
          <li>
            <Link to="contact" smooth={true} duration={500} onClick={() => setMenuOpen(false)}>
              Contact
            </Link>
          </li>
        </ul>
        <div className="hamburger" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
